<template>
  <div style="position: fixed;top:10%;left:5%;right:5%;bottom:10%;background: white;z-index: 999;display: block">
    <iframe style="height: 100%;width: 100%" :src="url" ></iframe>
  </div>
  <div @click="$emit('close')" style="    position: fixed;
    top: 9%;
    right: 4%;
    z-index: 1000;
    height: 22px;
    color: white;
    padding: 5px;
    border-radius: 5px;
    margin: 0;
    font-size: 12px;
    line-height: 12px;
    background: black;">❌ Close</div>
</template>
  
  <script>
  export default {
    props: {
      url: {
        type: String,
        required: true,
      },
    },
  };
  </script>
